import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { sidePanelYesNoAnswers } from 'app/modules/grant-review/constants/side-panel-answers.const';

@Component({
  selector: 'app-site-visit-org-structure',
  templateUrl: './site-visit-org-structure.component.html',
  styleUrls: ['./site-visit-org-structure.component.scss']
})
export class SiteVisitOrgStructureComponent implements OnInit {

  theme: 'dark' | 'light' = 'light';
  style: 'default' | 'bordered' = 'default';

  @Input() siteVisitOrgStructureForm: FormGroup;
  @Input() isReadOnly: boolean;

  siteVisitOrgStructureAnswers = sidePanelYesNoAnswers;
  constructor() { }

  ngOnInit() {
  }

}
